import _classCallCheck from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { createRef } from 'react';
import parse from 'html-react-parser';
import Accordion from 'react-bootstrap/Accordion';
// components
import IconsHolder from '../icons-holder/IconsHolder';
import CustomLink from '../custom-link/CustomLink';
var HeaderDropdown = /*#__PURE__*/function (_React$Component) {
  function HeaderDropdown(props) {
    var _this;
    _classCallCheck(this, HeaderDropdown);
    _this = _callSuper(this, HeaderDropdown, [props]);
    _defineProperty(_this, "tabRef", createRef());
    _this.state = {
      tabHoverId: ''
    };
    return _this;
  }
  _inherits(HeaderDropdown, _React$Component);
  return _createClass(HeaderDropdown, [{
    key: "handleTabLinkMouseOver",
    value: function handleTabLinkMouseOver(id) {
      this.setState(function () {
        return {
          tabHoverId: id
        };
      });
    }
  }, {
    key: "handleTabLinkMouseLeave",
    value: function handleTabLinkMouseLeave() {
      if (!this.tabRef.current.matches(':hover')) {
        this.setState(function () {
          return {
            tabHoverId: ''
          };
        });
      }
    }
  }, {
    key: "backToMenu",
    value: function backToMenu(id) {
      this.props.backToMenu(id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return React.createElement("div", {
        className: "dropdown-wrapper ".concat(this.props.menu.id, "-drp")
      }, React.createElement("div", {
        className: "container py-3 d-flex d-lg-none back-menu"
      }, React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return _this2.backToMenu(_this2.props.menu.id);
        },
        className: "btn p-0 h6 text-center w-100",
        "aria-label": "Back to the previous menu."
      }, React.createElement("span", null, this.props.menu.tabName))), React.createElement("div", {
        className: "content flex-fill justify-content-lg-between d-flex flex-column flex-lg-row"
      }, React.createElement("ul", {
        className: "container nav-links py-lg-4 text-sm-left pb-3 px-lg-0"
      }, this.props.menu.drpMainCategories.map(function (category, index) {
        if (category.link && category.title) {
          return React.createElement("li", {
            // eslint-disable-next-line react/no-array-index-key
            key: "".concat(_this2.props.menu.id, "-m-").concat(index),
            className: "d-flex align-items-center position-relative ".concat(_this2.state.tabHoverId === "".concat(_this2.props.menu.id, "-tab-").concat(index) ? 'active' : ''),
            onMouseEnter: function onMouseEnter() {
              return _this2.handleTabLinkMouseOver("".concat(_this2.props.menu.id, "-tab-").concat(index));
            },
            onMouseLeave: function onMouseLeave() {
              return _this2.handleTabLinkMouseLeave();
            }
          }, React.createElement(IconsHolder, {
            icon: category.icon,
            variant: "primary",
            className: "align-self-start",
            size: "md"
          }), React.createElement("div", {
            className: "ms-3"
          }, React.createElement(CustomLink, {
            isLink: category.linkType === _this2.props.pageType,
            className: "h6 stretched-link",
            href: category.link
          }, parse(category.title)), category.subcopy && React.createElement("p", {
            className: "body-text-sm text-gray mb-0"
          }, parse(category.subcopy))));
        }
        return null;
      })), React.createElement("div", {
        ref: this.tabRef,
        className: "nav-add flex-fill"
      }, React.createElement("div", {
        className: "container d-lg-flex align-items-lg-start py-3 p-lg-0"
      }, this.props.menu.drpTabFixed && React.createElement("div", {
        className: "fixed-tab-container py-3 p-lg-6"
      }, React.createElement("h6", {
        className: "eyebrow-text mb-3 text-secondary"
      }, this.props.menu.drpTabFixed.title), React.createElement("ul", {
        className: "ps-0"
      }, this.props.menu.drpTabFixed.links.map(function (link, i) {
        return (
          // eslint-disable-next-line react/no-array-index-key
          React.createElement("li", {
            key: "header-".concat(i, "-key8")
          }, React.createElement(CustomLink, {
            isLink: link.linkType === _this2.props.pageType,
            href: link.link
          }, parse(link.title)))
        );
      }))), React.createElement("div", {
        className: "py-3 p-lg-6"
      }, React.createElement("h6", {
        id: "".concat(this.props.menu.id, "-advtitle"),
        className: "eyebrow-text mb-lg-3 text-secondary"
      }, this.props.menu.adviceTitle), React.createElement(Accordion, {
        flush: true,
        id: "".concat(this.props.menu.id, "-tab-wrap"),
        alwaysOpen: true,
        className: "tab-wrap mb-0 accordion-angle-icon accordion-lg-none"
      }, this.props.menu.drpMainCategories.map(function (cat, index) {
        return React.createElement(Accordion.Item
        // eslint-disable-next-line react/no-array-index-key
        , {
          // eslint-disable-next-line react/no-array-index-key
          key: "".concat(_this2.props.menu.id, "-key2-").concat(index),
          eventKey: "".concat(_this2.props.menu.id, "-tab").concat(index, "-wrap")
        }, React.createElement(Accordion.Button, {
          "aria-controls": "".concat(_this2.props.menu.id, "-tab").concat(index),
          className: "tabpanel-control body-text-sm d-lg-none"
        }, cat.advice.mobileTitle), React.createElement(Accordion.Body, {
          "aria-labelledby": "".concat(_this2.props.menu.id, "-advtitle"),
          as: "ul",
          id: "".concat(_this2.props.menu.id, "-tab").concat(index),
          className: "advice-box pl-md-0 ".concat(_this2.state.tabHoverId === "".concat(_this2.props.menu.id, "-tab-").concat(index) || !_this2.state.tabHoverId && index === 0 ? 'd-lg-block' : 'd-lg-none')
        }, cat.advice.links.map(function (link, i) {
          return (
            // eslint-disable-next-line react/no-array-index-key
            React.createElement("li", {
              key: "".concat(_this2.props.menu.id, "-key3-").concat(i)
            }, React.createElement(CustomLink, {
              isLink: link.linkType === _this2.props.pageType,
              href: "".concat(link.link)
            }, parse(link.title)))
          );
        })));
      })))))));
    }
  }]);
}(React.Component);
export { HeaderDropdown as default };